import { useState, useEffect } from 'preact/hooks';

export default function useRemainingSessionTime({ timeInSession, ruleInstance, index }) {
	const sessionTime = ruleInstance?.getConditionState(index, state => state.sessionTime);

	const [remaining, setRemaining] = useState(() => {
		const time = timeInSession - sessionTime;
		return isNaN(time) ? timeInSession : time;
	});

	useEffect(() => {
		if (remaining <= 0 || !timeInSession) {
			return;
		}

		const interval = setInterval(() => {
			if (remaining === 0) {
				clearInterval(interval);
			}
			const currentSessiontime = ruleInstance?.getConditionState(index, state => state.sessionTime);
			const time = timeInSession - currentSessiontime;
			setRemaining(isNaN(time) ? timeInSession : time);
		}, 1000);

		return () => clearInterval(interval);
	}, [remaining, timeInSession, ruleInstance, index]);

	return {
		remaining,
		finished: remaining <= 0 || !timeInSession,
	};
}
